import './ConsentedClient.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Store from 'state/Store';
import { getView } from 'state/view/ViewSelectors';
import ProductCard from 'components/shared/ProductCard/ProductCard';
import { ReactComponent as YodleeLogo } from 'assets/logo/logo-yodlee.svg';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import ExternalInvestmentLearnMoreModal from 'components/shared/ExternalInvestmentLearnMore/ExternalInvestmentLearnMoreModal';
import { initializeVendorSession } from 'state/session/SessionActions';
import {
  delayLinkAccount,
  showConsentModal,
  showLinkModal
} from 'state/external/ExternalInvestmentConsentActions';
import Content from 'services/Content';

import { getExternalInvestmentConsent } from 'state/external/ExternalInvestmentConsentSelectors';

import { accountCenterLinks, linkBuilder } from 'services/Externals';

const ExternalLinkButton = ({ href, handleClick, label }) => {
  if (href) {
    return (
      <a className="external-link-button no-underline" href={href}>
        {label}
      </a>
    );
  }
  return (
    <a className="external-link-button" onClick={handleClick}>
      {label}
    </a>
  );
};

const ExternalInvestmentTitle = () => (
  <Fragment>
    <p>EXTERNAL INVESTMENT ACCOUNTS</p>
  </Fragment>
);

const ExternalInvestmentCardBottom = ({ children }) => (
  <div className="external-investment-card-bottom">{children}</div>
);

const ExternalInvestmentLogo = () => (
  <YodleeLogo className="external-investment-card-bottom-logo" />
);

const ExternalLinkButtonWithPermissions =
  WithUserPermissions(ExternalLinkButton);

export const activateExternalAccountSession = () => {
  Store.dispatch(
    initializeVendorSession({ name: 'externalAccount', active: true })
  );
};

const ProspectiveClient = ({ consent, setAutoOpen, view }) => {
  return (
    <ProductCard
      content={Content.externalInvestment.noConsent}
      className="external-investment-card module-container"
      title={<ExternalInvestmentTitle />}
      description="Link your external investment accounts">
      <ExternalInvestmentCardBottom>
        <ExternalInvestmentLearnMoreModal
          className="external-investment-learn-more"
          content={Content.externalInvestmentLearnMore}
          title="Learn More"
        />
        <ExternalLinkButtonWithPermissions
          handleClick={() => {
            if (!consent) {
              Store.dispatch(showConsentModal(true));
              Store.dispatch(delayLinkAccount(true));
              setAutoOpen('LINK');
            } else {
              Store.dispatch(showLinkModal(true));
            }
          }}
          label="Link an Account"
          styleOverride={{ display: 'inline' }}
          shouldDisable
          view={view}
        />
        <ExternalLinkButtonWithPermissions
          handleClick={() => {
            if (!consent) {
              Store.dispatch(showConsentModal(true));
              setAutoOpen('ACCOUNT_CENTER');
            } else {
              const accountCenter = linkBuilder(accountCenterLinks, view);
              window.location.href = accountCenter;
            }
          }}
          shouldDisable
          view={view}
          label="Account Center"
        />
        <div className="logo-container">
          <ExternalInvestmentLogo />
        </div>
      </ExternalInvestmentCardBottom>
    </ProductCard>
  );
};

const mapStateToProps = (state) => ({
  consent: getExternalInvestmentConsent(state),
  view: getView(state)
});

export default connect(mapStateToProps)(ProspectiveClient);
